import requests from './index';
import properties from './properties';

const { _API_PREFIX_CALENDAR } = properties;
/**
 *
 * @returns
 */
export const getUserInfoAPI = () => {
  return requests.get(`${_API_PREFIX_CALENDAR}/loginuser`);
};
